import React, { useEffect, useRef } from "react";

import Carousel from "react-elastic-carousel";

import Lead from './Lead';
import About from './About';
import Experience from './Experience';
import Projects from './Projects';
import Contact from './Contact';

export default function Slider() {
  const prevItemObject = "prev";
  const nextItemObject = "next";
  let indexPage = 0;
  let scrollEnabled = true;

  const slider = useRef(null);

  function disableScroll() {
      scrollEnabled = false;

      setTimeout(function() {
          scrollEnabled = true;
      }, 500);
  }

  function scroll(e) {
    if (scrollEnabled){
      if (slider === null) return 0;

      var numPages = slider.current.getNumOfPages() - 1;

      if(e.wheelDelta > 0 && indexPage > 0){
        indexPage = indexPage - 1;
        slider.current.onPrevStart()
      } else if(e.wheelDelta < 0 && indexPage < numPages) {
        indexPage = indexPage + 1;
        slider.current.onNextStart(prevItemObject, nextItemObject);
      }
      disableScroll();
    }
  }

  function change(object,index){
    calculateSliderProgress(index);

    if(index != 0){
      document.getElementById('copyright').classList.add('active');
      const navItem = document.querySelector('.nav-link.active');
      if(navItem){
        navItem.classList.remove("active");
      }
      document.querySelector('.nav-link.link-'+ index).classList.add('active');
    }else{
      document.getElementById('copyright').classList.remove('active');
      const navItem = document.querySelector('.nav-link.active');
      if(navItem){
        navItem.classList.remove("active");
      }
    }
  }

  function goToSlide(id) {
    if (slider === null) return 0;
    indexPage = id;
    const prevNavItem = document.querySelector('.nav-link.active');
    if(prevNavItem !== null){
      prevNavItem.classList.remove("active");
    }
    document.querySelector('.nav-link.link-'+ id).classList.add("active");
    slider.current.goTo(Number(id));
    calculateSliderProgress(indexPage);
  }

  function calculateSliderProgress(indexPage){
    var numPages = slider.current.getNumOfPages() - 1;
    const percentage = (indexPage / numPages) * 100;
    document.getElementById('slider-progress').style.setProperty('width', percentage + '%');
  }

  useEffect(() => {
    window.addEventListener("wheel", scroll, true);

    return () => {
      window.removeEventListener("wheel", scroll, false);
    };
  }, []);

  return (
    <>
      <header className="portfolio-header">
      <div className="ui-titlebar">
         <div className="ui-titletext">D:\projects\classified</div>
         <div className="ui-titlecontrols">
           <button className="ui-btn minimize">
             <svg x="0px" y="0px" viewBox="0 0 10.2 1"><rect x="0" y="50%" width="10.2" height="1" /></svg>
           </button><button className="ui-btn maximize">
             <svg viewBox="0 0 10 10"><path d="M0,0v10h10V0H0z M9,9H1V1h8V9z" /></svg>
           </button><button className="ui-btn close">
             <svg viewBox="0 0 10 10"><polygon points="10.2,0.7 9.5,0 5.1,4.4 0.7,0 0,0.7 4.4,5.1 0,9.5 0.7,10.2 5.1,5.8 9.5,10.2 10.2,9.5 5.8,5.1" /></svg>
           </button>
         </div>
       </div>
       <nav className="navbar fixed-top navbar-expand-lg custom">
         <button className="navbar-toggler collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
           <span> </span>
           <span> </span>
           <span> </span>
         </button>
         <div className="collapse navbar-collapse justify-content-end" id="navbarNavAltMarkup">
           <div className="navbar-nav">
             <a className="nav-link link-1" onClick={() => goToSlide(1)}>About Me</a>
             <a className="nav-link link-2" onClick={() => goToSlide(2)}>Experience</a>
             <a className="nav-link link-3" onClick={() => goToSlide(3)}>Projects</a>
             <a className="nav-link link-4" onClick={() => goToSlide(4)}>Contact</a>
           </div>
         </div>
       </nav>
      </header>
      <Carousel
        onScroll={scroll}
        onChange={change}
        verticalMode
        itemsToShow={1}
        enableSwipe={true}
        preventDefaultTouchmoveEvent={true}
        pagination={false}
        showArrows={false}
        ref={slider}
      >
        <Lead goToSlide={goToSlide}></Lead>
        <About goToSlide={goToSlide}></About>
        <Experience></Experience>
        <Projects></Projects>
        <Contact></Contact>
      </Carousel>
      <div id="slider-progress"></div>
    </>
  );
};
